/**
 * Note to developers. This entire package should be deprecated in support of `map-back-end`
 */
const request = require('superagent')
const _ = require('lodash')

const RXNORM_RXCUI = 'http://www.nlm.nih.gov/research/umls/rxnorm'
const FHIR_NDC = 'http://hl7.org/fhir/sid/ndc'
const FDB_ROUTE = 'http://docs.fdbhealth.com/display/CCDOCUS/Routes+by+Identifier'

const getRXCUICoding = medication => {
  return _.filter(_.get(medication, 'code.coding'), coding => coding.system === RXNORM_RXCUI)[0]
}

const getNDCCoding = medication => {
  return _.filter(_.get(medication, 'code.coding'), coding => coding.system === FHIR_NDC)[0]
}

const getRoute = medication => {
  let route
  const extension = _.get(medication, 'extension', [])
  for (let i = 0; i < extension.length; i++) {
    const valueCodeableConcept = _.get(extension[i], 'valueCodeableConcept.coding', [])
    for (let j = 0; j < valueCodeableConcept.length; j++) {
      const concept = valueCodeableConcept[j]
      if (concept.system === FDB_ROUTE) {
        route = concept
      }
    }
  }

  return route
}

const getCoding = medication => {
  return _.get(medication, 'code.coding', []).map(coding => {
    coding.value = coding.code
    return coding
  })
}

module.exports = (config, authorization) => {
  return {
    systems: {
      RXNORM_RXCUI,
      FHIR_NDC,
      FDB_ROUTE
    },
    /**
     * Search for medications. See [Docs](https://medwise-docs.develop.ckapps.io/medwise-api-docs/#/Medications/medicationSearch) for more details
     * @param  {Object}  options [description]
     * @return {Promise}         [description]
     */
    searchMedications: async options => {
      const uri = `${config.gatewayApi.host}/api/fdb/medication`
      const result = await request
        .get(uri)
        .query(options)
        .set('Accept', 'application/json')
        .set('Authorization', authorization)
        .retry(4)
        .timeout(10000) // 10 seconds
      return result.body
    },

    getRXCUICoding,
    getNDCCoding,
    getRoute,
    getCoding,

    /**
     * This should mostly be deprecated in the new backend, since we will actually be storing MedicationStatments
     * with Medication bundled inside. However, we might have some custom stuff we want to keep.
     * @param  {Object}  medication The Medication object
     * @return {Promise}            [description]
     */
    buildMedication: medication => {
      if (!_.get(medication, 'code.coding')) {
        throw new Error('Missing valid medication')
      }

      const route = getRoute(medication)

      const coding = getCoding(medication)

      return {
        type: 'patient.medication',
        dosageInstructions: {
          route: {
            Id: route ? route.code : '0',
            Name: route ? route.display : 'N/A'
          },
          text: '', // sig,
          timingSchedule: {},
          asNeeded: false
        },
        medication: {
          code: {
            coding: coding
          },
          isBrand: false, // Don't think this is used anywhere that's really important anymore.
          name: {
            full: _.capitalize(medication.code.text)
          },
          product: {
            drug: {
              code: coding
            },
            form: {
              code: _.get(medication, 'form.coding') // this is silly, but would rather match it, than do an OR
            },
            strength: {
              code: [
                {
                  system: _.get(medication, 'ingredient[0].amount.numerator.system'),
                  value: _.get(medication, 'ingredient[0].amount.numerator.value', 'N/A'),
                  code: _.get(medication, 'ingredient[0].amount.numerator.code', ''),
                  display: _.get(medication, 'ingredient[0].amount')
                    ? _.get(medication, 'ingredient[0].amount.numerator.value', 'N/A') +
                      ' ' +
                      _.get(medication, 'ingredient[0].amount.numerator.code')
                    : 'N/A'
                }
              ]
            }
          },
          tierLevel: medication.tierLevel || 'N',
          isFormulary: medication.isFormulary || false
          // Need to update formulary service to get this, maybe?
          // Not sure, maybe FDB's search results gives enough.
          // Additional research necessary.
        }
      }
    }
  }
}
